<template>
  <div>
    <message :messages="messages"></message>
    <v-card>
      <v-card-title>
        <div class="body-2">{{labels.quoteInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.product" v-model="paForm.product" :label="labels.product" item-text="label" item-value="value" data-vv-name="product" :data-vv-as="labels.product" :error-messages="errors.collect('product')" v-validate="'required'" @input="doProduct"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field v-int-mask="{intScale: 3}" v-model="paForm.noAdult" :label="labels.noAdult" type="tel" :error-messages="errors.collect('noAdult')" data-vv-name="noAdult" :data-vv-as="labels.noAdult" v-validate="'required|numeric|max_value:999|min_value:0'"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-int-mask="{intScale: 3}" v-model="paForm.noChild" :label="labels.noChild" type="tel" :error-messages="errors.collect('noChild')" data-vv-name="noChild" :data-vv-as="labels.noChild" v-validate="'required|numeric|max_value:999|min_value:0'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <v-layout row wrap>
                <v-flex xs7 v-if="isStaff">
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['paQuoteAcceptDate'])" @input="doAcceptDate" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate"  v-validate="'required|accept_today_date'" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['paQuoteAcceptDate'])" @input="doAcceptDate" :max="minStartDate"></cal-picker-->
                </v-flex>
                 <v-flex xs7 v-else>
                  <cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['paQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" ></cal-picker>
                  <!--cal-picker v-model="acceptDate" :label="labels.acceptDate" v-validate="acceptDateValidation" :data-vv-as="labels.acceptDate" data-vv-name="acceptDate" :error-messages="errors.collect('acceptDate')" :readonly="!checkAccess(['paQuoteAcceptDate'])" @input="doAcceptDate" :min="this.backDateLimit" :max="minStartDate"></cal-picker-->
                </v-flex>
                <v-flex xs5>
                  <time-picker v-model="acceptTime" :label="labels.acceptTime" v-validate="'required'" :data-vv-as="labels.acceptTime" data-vv-name="acceptTime" :error-messages="errors.collect('acceptTime')" :readonly="!checkAccess(['paQuoteAcceptDate'])" @input="doAcceptDate"></time-picker>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="paForm.startDate" :label="labels.startDate" v-validate="startDateValidation" :data-vv-as="labels.startDate" data-vv-name="startDate" :error-messages="errors.collect('startDate')" @input="doStartDate" :min="this.acceptDate" :max="maxStartDate"></cal-picker>
            </v-flex>
            <v-flex lg6 xs12>
              <cal-picker v-model="paForm.endDate" :label="labels.endDate" v-validate="endDateValidation" :data-vv-as="labels.endDate" data-vv-name="endDate" :error-messages="errors.collect('endDate')" :min="this.paForm.startDate" :disabled="paForm.tripType === 'A'" :hint="daysCoverage" :max="maxEndDate"></cal-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card v-if="quoteParam.discLdg && quoteParam.discLdg.length > 0" class="mt-3">
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex md6 xs12>
              <v-autocomplete v-model="tempAddDiscLdg" :items="addDiscLdgList" label="Add Loadings" item-text="discLdgDesc" item-value="discLdg" prepend-icon="mdi-playlist-plus" outline clearable @change="doAddDiscLdg"></v-autocomplete>
            </v-flex>
            <v-flex md6 xs12></v-flex>
            <v-flex xs12 v-for="discLdg in removeDiscLdgList" :key="discLdg.discLdg">
              <v-checkbox v-model="paForm.discLdg" :label="discLdg.discLdgDesc" :value="discLdg.discLdg" hide-details></v-checkbox>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-card class="mt-3">
      <v-card-title>
        <div class="body-2">{{labels.cpInfo}}</div>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.campaign" v-model="paForm.campaign" :label="labels.campaign" item-text="label" item-value="value" data-vv-name="campaign" :data-vv-as="labels.campaign" :error-messages="errors.collect('campaign')" clearable :loading="campaignLoading" @input="doCampaign"></v-autocomplete>
            </v-flex>
            <v-flex lg6 xs12>
              <v-autocomplete :items="quoteParam.promotion" v-model="paForm.promotion" :label="labels.promotion" item-text="label" item-value="value" data-vv-name="promotion" :data-vv-as="labels.promotion" :error-messages="errors.collect('promotion')" clearable :loading="promotionLoading"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout row wrap class="mt-3">
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed" :disabled="proceedLoading">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import clone from 'clone'
import toDate from 'date-fns/toDate'
import addYears from 'date-fns/addYears'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import differenceInDays from 'date-fns/differenceInDays'
import isAfter from 'date-fns/isAfter'
import { AGENCY_QUOTATION_LIFECYCLE, QUOTE_PA_PARAM_GENERAL, QUOTE_PA_PARAM } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { extractRecord } from '@/utils/extract'
import { formatDisplayTime, removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        quoteInfo: 'Quotation Information',
        product: 'Product*',
        paArea: 'Geographical Area*',
        countriesTitle: 'Geographical Area Locator',
        countries: 'Destination Country',
        acceptDate: 'Acceptance Date*',
        acceptTime: 'Time*',
        noAdult: 'No. of Adult(s)*',
        noChild: 'No. of Child(ren)*',
        startDate: 'Start Date*',
        endDate: 'End Date*',
        cpInfo: 'Campaign/Promotion',
        campaign: 'Campaign',
        promotion: 'Promotion',
        discLdg: 'Loadings'
      },
      paForm: {
        product: undefined,
        scheme: undefined,
        acceptDate: undefined,
        noAdult: undefined,
        noChild: undefined,
        startDate: undefined,
        endDate: undefined,
        campaign: undefined,
        promotion: undefined,
        discLdg: []
      },
      countriesPnl: false,
      countries: [],
      resolveRegion: undefined,
      acceptDate: undefined,
      acceptTime: undefined,
      campaignLoading: false,
      promotionLoading: false,
      discLdgLoading: false,
      tempAddDiscLdg: null
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    globalForm() {
      return this.$store.state.agency.quotation.paForm
    },
    quoteParam() {
      return this.$store.state.agency.quotation.paParam
    },
    isStaff() {
      return this.$store.state.agency.quotationSettings.isStaff
    },
    selectedProduct() {
      if (this.paForm.product) {
        return extractRecord(this.quoteParam.product, this.paForm.product)
      } else {
        return null
      }
    },
    backDateDays() {
      const product = this.selectedProduct
      if (product) {
        return product.backDateAcceptDays
      } else {
        return null
      }
    },
    backDateLimit() {
      if (this.backDateDays !== null || this.backDateDays !== undefined) {
        if (this.backDateDays === 0) {
          return new Date()
        } else {
          return subDays(new Date(), this.backDateDays)
        }
      } else return null
    },
    acceptDateValidation() {
      // const result = 'required|accept_back_date:' + this.backDateDays + '|accept_start_date:' + this.paForm.startDate + '|accept_today_date'
      // return 'required|accept_back_date:' + this.backDateDays + '|accept_today_date'
      return 'required|accept_back_date:' + this.backDateDays
    },
    daysBeforeCover() {
      if (this.paForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.paForm.product)
        if (productParam) {
          return productParam.maxDaysBeforeCover
        }
      }
      return undefined
    },
    minStartDate() {
      return new Date()
    },
    maxStartDate() {
      if (this.daysBeforeCover !== undefined) {
        let result = new Date()
        result.setHours(0, 0, 0, 0)
        result = addDays(result, this.daysBeforeCover)
        return result
      }
      return undefined
    },
    startDateValidation() {
      // return 'required|start_before_today|days_before_cover:' + this.daysBeforeCover
      return 'required|start_before_date:' + this.acceptDate + '|days_before_cover:' + this.daysBeforeCover
    },
    endDateValidation() {
      return 'required|start_enddate:' + this.paForm.startDate + '|quote_pa_covered:' + this.paForm.tripType + ',' + this.paForm.startDate + ',' + this.maxDaysCovered
    },
    daysCoverage() {
      if (this.paForm.startDate && this.paForm.endDate) {
        return 'Days Covered: ' + (differenceInDays(toDate(this.paForm.endDate), toDate(this.paForm.startDate)) + 1)
      } else {
        return undefined
      }
    },
    maxDaysCovered() {
      if (this.paForm.product) {
        const productParam = extractRecord(this.quoteParam.product, this.paForm.product)
        if (productParam) {
          return productParam.maxDaysCovered
        }
      }
      return undefined
    },
    maxEndDate() {
      if (this.paForm.tripType === 'S' && this.paForm.startDate && this.maxDaysCovered !== undefined) {
        let result = removeTime(toDate(this.paForm.startDate))
        result = addDays(result, (this.maxDaysCovered - 1))
        return result
      } else {
        return undefined
      }
    },
    proceedLoading() {
      if (this.campaignLoading || this.promotionLoading || this.discLdgLoading) {
        return true
      } else {
        return false
      }
    },
    addDiscLdgList() {
      const addDiscLdgParam = this.quoteParam.discLdg
      if (addDiscLdgParam && addDiscLdgParam.length > 0) {
        let result = []
        for (let discLdg of addDiscLdgParam) {
          // Check if its already inside DiscLdgForm
          if (this.paForm.discLdg.length > 0) {
            if (!this.paForm.discLdg.find(a => a === discLdg.discLdg)) {
              result.push(discLdg)
            }
          } else {
            result.push(discLdg)
          }
        }
        return result
      }
      return []
    },
    removeDiscLdgList() {
      const addDiscLdgParam = this.quoteParam.discLdg
      if (addDiscLdgParam && addDiscLdgParam.length > 0) {
        let result = []
        for (let discLdg of addDiscLdgParam) {
          // Check if its already inside DiscLdgForm
          if (this.paForm.discLdg.length > 0) {
            if (this.paForm.discLdg.find(a => a === discLdg.discLdg)) {
              result.push(discLdg)
            }
          }
        }
        return result
      }
      return []
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      this.paForm.product = this.globalCommonForm.product
      this.paForm.scheme = this.globalCommonForm.scheme
      this.paForm.paType = this.globalForm.paType
      this.paForm.noAdult = this.globalForm.noAdult
      this.paForm.noChild = this.globalForm.noChild
      this.paForm.startDate = this.globalCommonForm.startDate
      this.paForm.endDate = this.globalCommonForm.endDate
      this.paForm.acceptDate = this.globalCommonForm.acceptDate
      this.paForm.campaign = this.globalCommonForm.campaign
      this.paForm.promotion = this.globalCommonForm.promotion
      if (this.globalCommonForm.discLdg && this.globalCommonForm.discLdg.length > 0) {
        this.$set(this.paForm, 'discLdg', clone(this.globalCommonForm.discLdg))
      }

      // Need break down acceptDate into date and time for input
      if (this.paForm.acceptDate) {
        this.acceptDate = this.paForm.acceptDate
        this.acceptTime = formatDisplayTime(this.paForm.acceptDate)
      }

      // Flag to determine whether to run snowball method
      let doParams = false

      if (!this.paForm.product) {
        if (this.quoteParam.product && this.quoteParam.product.length > 0) {
          // This is to load 1st value if its a fresh quotation
          this.paForm.product = this.quoteParam.product[0].value
          doParams = true
        }
      } else {
        if (!this.quoteParam.generalLoaded) {
          doParams = true
        }
      }

      if (this.paForm.noAdult === null) {
        this.paForm.noAdult = 0
      }
      if (this.paForm.noChild === null) {
        this.paForm.noChild = 0
      }

      if (doParams) {
        this.doProduct()

        // Need to do after doProduct (maxDaysCovered and stuff)
        // Start and End Date
        if (!this.paForm.startDate) {
          const today = new Date()
          today.setHours(0, 0, 0, 0)
          this.paForm.startDate = today
          this.doStartDate()
        }
        this.$store.commit(QUOTE_PA_PARAM_GENERAL)
      }
    },
    doProduct() {
      if (this.paForm.acceptDate && this.paForm.product) {
        this.getCampaign()
      } else {
        this.paForm.campaign = undefined
        this.doCampaign()
      }
    },
    doStartDate() {
      if (this.paForm.startDate) {
        // Add 1 year to end Date
        let endDate = addYears(this.paForm.startDate, 1)
        endDate = subDays(endDate, 1)
        this.paForm.endDate = endDate
      } else {
        this.paForm.endDate = null
      }
    },
    doAcceptDate() {
      // Format Accept Date
      if (this.checkAccess(['paQuoteAcceptDate'])) {
        if (this.acceptDate && this.acceptTime && this.acceptTime.length === 5) {
          const hr = this.acceptTime.substring(0, 2)
          const min = this.acceptTime.substring(3, 5)
          this.acceptDate = toDate(this.acceptDate)
          this.acceptDate.setHours(hr)
          this.acceptDate.setMinutes(min)
          this.paForm.acceptDate = this.acceptDate
        }
      }
      if (this.paForm.product && this.paForm.acceptDate) {
        this.getCampaign()
      } else {
        this.paForm.campaign = undefined
        this.doCampaign()
      }
    },
    async getCampaign() {
      const apiURI = this.$store.state.agency.quotation.menu.campaign
      if (apiURI) {
        try {
          const expand = {
            product: this.paForm.product,
            intermediary: this.globalCommonForm.intermediary,
            acceptDate: formatDisplayDateTime2(this.paForm.acceptDate)
          }
          this.campaignLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              campaign: data.data
            }
            this.$store.commit(QUOTE_PA_PARAM, commitResult)
          }
          this.campaignLoading = false

          if (this.paForm.campaign && this.quoteParam.campaign && this.quoteParam.campaign.length > 0) {
            // Check if the current campaign value is still valid
            let campaignIsValid = false
            for (var i = 0; i < this.quoteParam.campaign.length; i++) {
              const campaign = this.quoteParam.campaign[i]
              if (campaign.value === this.paForm.campaign) {
                campaignIsValid = true
                break
              }
            }
            // Invalid Campaign (reset to undefined)
            if (!campaignIsValid) {
              this.paForm.campaign = undefined
            } else { }
          } else {
            this.paForm.campaign = undefined
          }
          // Do campaign (get promotion)
          this.doCampaign()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.campaignLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doCampaign() {
      if (this.paForm.campaign && this.paForm.acceptDate) {
        this.getPromotion()
      } else {
        this.paForm.promotion = undefined
      }
    },
    async getPromotion() {
      const apiURI = this.$store.state.agency.quotation.menu.promotion
      if (apiURI) {
        try {
          const expand = {
            campaign: this.paForm.campaign,
            acceptDate: formatDisplayDateTime2(this.paForm.acceptDate)
          }
          this.promotionLoading = true
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            const { data } = result
            const commitResult = {
              promotion: data.data
            }
            this.$store.commit(QUOTE_PA_PARAM, commitResult)
          }
          this.promotionLoading = false

          if (this.paForm.promotion && this.quoteParam.promotion && this.quoteParam.promotion.length > 0) {
            // Check if the current promotion value is still valid
            let promotionIsValid = false
            for (var i = 0; i < this.quoteParam.promotion.length; i++) {
              const promotion = this.quoteParam.promotion[i]
              if (promotion.value === this.paForm.promotion) {
                promotionIsValid = true
                break
              }
            }
            // Invalid Promotion (reset to undefined)
            if (!promotionIsValid) {
              this.paForm.promotion = undefined
            }
          } else {
            this.paForm.promotion = undefined
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.resetMessages()
            this.message(data)
          }
          this.promotionLoading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Some form validation
          if ((this.paForm.noAdult + this.paForm.noChild) > 0) {
            if ((this.paForm.campaign && this.paForm.promotion) || (!this.paForm.campaign && !this.paForm.promotion)) {
              this.$store.dispatch('paQuoteGeneral', this.paForm)
              this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
              this.$router.push({ name: 'paQuotePlans' })
            } else {
              this.errorMessage('Please select a promotion if this quotation is participating in a campaign')
              this.promptFieldCheck()
            }
          } else {
            this.errorMessage('Please select at least 1 Insured Person')
            this.promptFieldCheck()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        await this.$store.dispatch('paQuoteGeneral', this.paForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 1) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 1)
    }
    this.doInit()
  },
  created() {
    // Load in local field validation
    // Name must be unique (as it will extend throughout the application)
    this.$validator.extend('quote_pa_covered', {
      getMessage(field, args) {
        if (args === void 0) args = [null, null, 0]
        return `Maximum duration for Single Trip is ${args[2]} day(s)`
      },
      validate(value, args) {
        if (args === void 0) args = [null, null, 0]
        const trip = args[0]
        let maxDate = args[1]
        const maxDays = Number(args[2])
        if (value && trip && maxDate && maxDays) {
          maxDate = addDays(removeTime(maxDate), (maxDays - 1))
          if (isAfter(removeTime(toDate(value)), maxDate)) return false
          else return true
        }
        return true
      }
    })
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss" scoped>
.loadingBox {
  max-width: 300px;
}
</style>
